module.exports = __webpack_public_path__ + "img/LTC-ability-03.aac63f59.png";